import { AttachMoney, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceCurrency = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <AttachMoney style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Currency")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <InvoiceFormField label={t("Currency")} type="disabled" code="Currency" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("CurrencyName")} type="disabled" code="CurrencyName" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}